const salesOrderFields = [
    { name: "ShippingDateFrom", label: "Ship Date From", type: "date" },
    { name: "ProfileCode", label: "Profile:", type: "text" },
    { name: "code1_OMHeader", label: "Code 1", type: "text" },
    { name: "code5_OMHeader", label: "Code 5", type: "text", visible: false },

    { name: "ShippingDateTo", label: "Ship Date To", type: "date" },
    { name: "RCustomer", label: "Customer:", type: "select", apiUrl: "om/SaleOrder/GetCustomers", options: [""] },
    { name: "code2_OMHeader", label: "Code 2", type: "text" },
    { name: "code6_OMHeader", label: "Code 6", type: "text", visible: false },

    { name: "OrderDateFrom", label: "Order Date From", type: "date" },
    { name: "TransactionNumber", label: "Transaction #", type: "text" },
    { name: "code3_OMHeader", label: "Code 3", type: "text" },
    { name: "code7_OMHeader", label: "Code 7", type: "text", visible: false },

    { name: "OrderDateTo", label: "Order Date To", type: "date" },
    { name: "PurchaseOrderNumber", label: "PO Number", type: "text" },
    { name: "code4_OMHeader", label: "Code 4", type: "text" },
    { name: "code8_OMHeader", label: "Code 8", type: "text", visible: false },

    { name: "code9_OMHeader", label: "Code 9", type: "text", visible: false },
    { name: "code10_OMHeader", label: "Code 10", type: "text", visible: false },
    { name: "code11_OMHeader", label: "Code 11", type: "text", visible: false },
    { name: "code12_OMHeader", label: "Code 12", type: "text", visible: false },
    { name: "code13_OMHeader", label: "Code 13", type: "text", visible: false },
    { name: "code14_OMHeader", label: "Code 14", type: "text", visible: false },
    { name: "code15_OMHeader", label: "Code 15", type: "text", visible: false },
    { name: "code16_OMHeader", label: "Code 16", type: "text", visible: false },
    { name: "code17_OMHeader", label: "Code 17", type: "text", visible: false },
    { name: "code18_OMHeader", label: "Code 18", type: "text", visible: false },
    { name: "code19_OMHeader", label: "Code 19", type: "text", visible: false },
    { name: "code20_OMHeader", label: "Code 20", type: "text", visible: false },
    { name: "reference1_OMHeader", label: "Reference 1", type: "text", visible: false },
    { name: "reference2_OMHeader", label: "Reference 2", type: "text", visible: false },
    { name: "reference3_OMHeader", label: "Reference 3", type: "text", visible: false },
    { name: "reference4_OMHeader", label: "Reference 4", type: "text", visible: false },
    { name: "reference5_OMHeader", label: "Reference 5", type: "text", visible: false },
    { name: "reference6_OMHeader", label: "Reference 6", type: "text", visible: false },
    { name: "reference7_OMHeader", label: "Reference 7", type: "text", visible: false },
    { name: "reference8_OMHeader", label: "Reference 8", type: "text", visible: false },
    { name: "reference9_OMHeader", label: "Reference 9", type: "text", visible: false },
    { name: "reference10_OMHeader", label: "Reference 10", type: "text", visible: false },
    { name: "reference11_OMHeader", label: "Reference 11", type: "text", visible: false },
    { name: "reference12_OMHeader", label: "Reference 12", type: "text", visible: false },
    { name: "reference13_OMHeader", label: "Reference 13", type: "text", visible: false },
    { name: "reference14_OMHeader", label: "Reference 14", type: "text", visible: false },
    { name: "reference15_OMHeader", label: "Reference 15", type: "text", visible: false },
    { name: "reference16_OMHeader", label: "Reference 16", type: "text", visible: false },
    { name: "reference17_OMHeader", label: "Reference 17", type: "text", visible: false },
    { name: "reference18_OMHeader", label: "Reference 18", type: "text", visible: false },
    { name: "reference19_OMHeader", label: "Reference 19", type: "text", visible: false },
    { name: "reference20_OMHeader", label: "Reference 20", type: "text", visible: false },
    { name: "date1_OMHeader", label: "Date 1", type: "date", visible: false },
    { name: "date2_OMHeader", label: "Date 2", type: "date", visible: false },
    { name: "date3_OMHeader", label: "Date 3", type: "date", visible: false },
    { name: "date4_OMHeader", label: "Date 4", type: "date", visible: false },
    { name: "date5_OMHeader", label: "Date 5", type: "date", visible: false },
    { name: "date6_OMHeader", label: "Date 6", type: "date", visible: false },
    { name: "date7_OMHeader", label: "Date 7", type: "date", visible: false },
    { name: "date8_OMHeader", label: "Date 8", type: "date", visible: false },
    { name: "date9_OMHeader", label: "Date 9", type: "date", visible: false },
    { name: "date10_OMHeader", label: "Date 10", type: "date", visible: false },
    { name: "date11_OMHeader", label: "Date 11", type: "date", visible: false },
    { name: "date12_OMHeader", label: "Date 12", type: "date", visible: false },
    { name: "date13_OMHeader", label: "Date 13", type: "date", visible: false },
    { name: "date14_OMHeader", label: "Date 14", type: "date", visible: false },
    { name: "date15_OMHeader", label: "Date 15", type: "date", visible: false },
    { name: "date16_OMHeader", label: "Date 16", type: "date", visible: false },
    { name: "date17_OMHeader", label: "Date 17", type: "date", visible: false },
    { name: "date18_OMHeader", label: "Date 18", type: "date", visible: false },
    { name: "date19_OMHeader", label: "Date 19", type: "date", visible: false },
    { name: "date20_OMHeader", label: "Date 20", type: "date", visible: false },
    { name: "quantity1_OMHeader", label: "Quantity 1", type: "text", visible: false },
    { name: "quantity2_OMHeader", label: "Quantity 2", type: "text", visible: false },
    { name: "quantity3_OMHeader", label: "Quantity 3", type: "text", visible: false },
    { name: "quantity4_OMHeader", label: "Quantity 4", type: "text", visible: false },
    { name: "quantity5_OMHeader", label: "Quantity 5", type: "text", visible: false },
    { name: "quantity6_OMHeader", label: "Quantity 6", type: "text", visible: false },
    { name: "quantity7_OMHeader", label: "Quantity 7", type: "text", visible: false },
    { name: "quantity8_OMHeader", label: "Quantity 8", type: "text", visible: false },
    { name: "quantity9_OMHeader", label: "Quantity 9", type: "text", visible: false },
    { name: "quantity10_OMHeader", label: "Quantity 10", type: "text", visible: false },
    { name: "quantity11_OMHeader", label: "Quantity 11", type: "text", visible: false },
    { name: "quantity12_OMHeader", label: "Quantity 12", type: "text", visible: false },
    { name: "quantity13_OMHeader", label: "Quantity 13", type: "text", visible: false },
    { name: "quantity14_OMHeader", label: "Quantity 14", type: "text", visible: false },
    { name: "quantity15_OMHeader", label: "Quantity 15", type: "text", visible: false },
    { name: "quantity16_OMHeader", label: "Quantity 16", type: "text", visible: false },
    { name: "quantity17_OMHeader", label: "Quantity 17", type: "text", visible: false },
    { name: "quantity18_OMHeader", label: "Quantity 18", type: "text", visible: false },
    { name: "quantity19_OMHeader", label: "Quantity 19", type: "text", visible: false },
    { name: "quantity20_OMHeader", label: "Quantity 20", type: "text", visible: false },
    { name: "userDefinedComment", label: "Comment", type: "text", visible: false },
    { name: "creationDateTime", label: "Created Date", type: "date", format: "MM/dd/yyyy", visible: false },
    { name: "creationUserId", label: "Created By", type: "text", visible: false },
    { name: "lastUpdateDateTime", label: "Last Updated", type: "date", format: "MM/dd/yyyy", visible: false },
    { name: "lastUpdateUserId", label: "Last Updated By", type: "text", visible: false },
    { name: "currencyRate", label: "Currency Rate", type: "text", visible: false },
    { name: "transCurrencyType", label: "Trans Currency Type", type: "text", visible: false },
    { name: "payCurrencyType", label: "Pay Currency Type", type: "text", visible: false },
    { name: "rateTiming", label: "Rate Timing", type: "text", visible: false },
    { name: "backOrderFlag", label: "Backorder", type: "text", visible: false },
    { name: "tripCubes", label: "Trip Cubes", type: "text", visible: false },
    { name: "transCurrency", label: "Trans Currency", type: "text", visible: false },
    { name: "payCurrency", label: "Pay Currency", type: "text", visible: false },
    { name: "address_2", label: "Address 2", type: "text", visible: false },
    { name: "city", label: "City", type: "text", visible: false },
    { name: "zip", label: "Zip", type: "text", visible: false },
    { name: "state", label: "State", type: "text", visible: false },
    { name: "telephone_1", label: "Telephone 1", type: "text", visible: false },
    { name: "fax_1", label: "Fax", type: "text", visible: false },
    { name: "consignee", label: "Consignee", type: "text", visible: false },
    { name: "consigneeName", label: "Consignee Name", type: "text", visible: false },
    { name: "consigneeAddress1", label: "Consignee Address1", type: "text", visible: false },
    { name: "consigneeAddress2", label: "Consignee Address2", type: "text", visible: false },
    { name: "consigneeCity", label: "Consignee City", type: "text", visible: false },
    { name: "consigneeZip", label: "Consignee Zip", type: "text", visible: false },
    { name: "consigneeState", label: "Consignee State", type: "text", visible: false },
    { name: "consigneePhone", label: "Consignee Phone", type: "text", visible: false },
    { name: "consigneeFax", label: "Consignee Fax", type: "text", visible: false },
    { name: "consigneeLocation", label: "Consignee Location", type: "text", visible: false },
    { name: "department", label: "Department", type: "text", visible: false },
    { name: "salesPerson1ID", label: "Sales Person1", type: "text", visible: false },
    { name: "salesPerson2ID", label: "Sales Person2", type: "text", visible: false },
    { name: "salesPerson3ID", label: "Sales Person3", type: "text", visible: false },
    { name: "salesPerson4ID", label: "Sales Person4", type: "text", visible: false },
    { name: "salesPerson5ID", label: "Sales Person5", type: "text", visible: false },
    { name: "shipVia", label: "Ship Via", type: "text", visible: false },
    { name: "termsCode", label: "Terms Code", type: "text", visible: false },
    { name: "transForeignItemTotal", label: "Trans Foreign Item Total", type: "text", visible: false },
    { name: "transDiscountBasisAmount", label: "Discount Basis Amount", type: "text", visible: false },
    { name: "transForeignDiscountBasisAmount", label: "Trans Foreign Discount Basis Amount", type: "text", visible: false },
    { name: "transDiscountAmount", label: "Trans Discount Amount", type: "text", visible: false },
    { name: "transForeignDiscountAmount", label: "Trans Foreign Discount Amount", type: "text", visible: false },
    { name: "transTaxableAmount", label: "Trans Taxable Amount", type: "text", visible: false },
    { name: "transForeignTaxableAmount", label: "Trans Foreign Taxable Amount", type: "text", visible: false },
    { name: "nonTaxable", label: "Non Taxable", type: "text", visible: false },
    { name: "transTaxRate", label: "Trans TaxRate", type: "text", visible: false },
    { name: "transForeignNonTaxableAmount", label: "Trans TaxableAmount", type: "text", visible: false },
    { name: "transTaxBasisAmount", label: "Trans Tax BasisAmount", type: "text", visible: false },
    { name: "transForeignTaxBasisAmount", label: "Trans Foreign Tax Basis Amount", type: "text", visible: false },
    { name: "transTaxAmount", label: "Trans TaxAmount", type: "text", visible: false },
    { name: "totalAmount", label: "Total Amount", type: "text", visible: false },
    { name: "transForeignTotalAmount", label: "Trans Total Amount", type: "text", visible: false },
    { name: "transForeignPaymentsAmount", label: "Trans Payments Amount", type: "text", visible: false },
    { name: "balanceDue", label: "Balance Due", type: "text", visible: false },
    { name: "transForeignBalanceDue", label: "Trans Foreign Balance Due", type: "text", visible: false },
    { name: "transQuantityOrdered", label: "Trans Quantity Ordered", type: "text", visible: false },
    { name: "transQuantityShipped", label: "Trans Quantity Shipped", type: "text", visible: false },
    { name: "transQuantityBackOrder", label: "Trans Quantity Back Order", type: "text", visible: false },
    { name: "transFeesAdded", label: "Trans Fees Added", type: "text", visible: false },
    { name: "transFeesIncluded", label: "Trans Fees Included", type: "text", visible: false },
    { name: "grossWeight", label: "Gross Weight", type: "text", visible: false },
    { name: "netWeight", label: "Net Weight", type: "text", visible: false },
    { name: "code10_Consignee", label: "Code10 Consignee", type: "text", visible: false },
    { name: "creditStatusReview", label: "Credit Status Review", type: "text", visible: false },
    { name: "creditReviewReason", label: "Credit Review Reason", type: "text", visible: false },
    { name: "creditReviewerId", label: "Credit Reviewer", type: "text", visible: false },
    { name: "creditReviewerName", label: "Credit Reviewer Name", type: "text", visible: false },
    { name: "creditReviewDate", label: "Credit Review Date", type: "date", format: "MM/dd/yyyy", visible: false },
    { name: "inventoryReview", label: "Inventory Review", type: "text", visible: false },
];

 

const FIELDS_PER_GROUP = 4;

const salesOrderSearchFormLayout = salesOrderFields.reduce((groups, field, index) => {
    const groupIndex = Math.floor(index / FIELDS_PER_GROUP);

    if (!groups[groupIndex]) {
        groups[groupIndex] = {
            groupId: groupIndex + 1,
            label: "",
            fields: []
        };
    }

    groups[groupIndex].fields.push({
        ...field,
        tableName: "",
        options: field.options ?? null,
        apiUrl: field.apiUrl ?? null,
        grid: null,
        required: false,
        visible: field.visible ?? true
    });

    return groups;
}, []);

export default salesOrderSearchFormLayout;
